import React from 'react'

import {Button} from '@ua/design-system/components/button'

type Props = {
  onCancel: () => void
  onSubmit: () => void
  isDisabled?: boolean
}

const FormActions = ({
  onCancel: handleOnCancel,
  onSubmit: handleOnSubmit,
  isDisabled,
}: Props): JSX.Element => {
  return (
    <>
      <div className="u-space-right-0">
        <Button variant="secondary" onClick={handleOnCancel}>
          Cancel
        </Button>
      </div>

      <Button
        variant="primary"
        onClick={handleOnSubmit}
        isDisabled={isDisabled}
      >
        Submit
      </Button>
    </>
  )
}

export default FormActions
